import { AppBar, Toolbar } from '@material-ui/core';
import styled from 'styled-components';

interface MuiAppBarProps {
    background_color: string;
    z_index: number;
}
export const MuiAppBar = styled(AppBar)<MuiAppBarProps>`
    border: 0px;
    background-color: ${(props) => props.background_color};
    z-index: ${(props) => props.z_index};
    touch-action: none;
`;

export const MuiToolBar = styled(Toolbar)`
    min-height: 48px;
    padding: 0px 4px;
    justify-content: flex-end;
`;
